import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { type A5Transaction, porfolios_columns } from "./columns";
import {
  type FilterA5TransactionsSchema,
  FilterA5Transactions,
} from "./filter";

const client = "a5";
const table_name = "a5_transactions";

export const A5TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<A5Transaction>({
    client,
    table_name,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<A5Transaction, FilterA5TransactionsSchema>
        label="Transactions"
        client={client}
        table_name={table_name}
        columns={porfolios_columns}
        filter={<FilterA5Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
